<div class="grades-container">
  @if(shouldShowGamePerformance()) {
    <div class="grade-item">
      <div class="grade-label">{{'SCOUTING.GAME' | translate}}</div>
      <div [class]="'grade-box ' + getGamePerformanceClass()">{{ gamePerformanceText() }}</div>
    </div>
  }

   @if(shouldShowPosition()) {
    <div class="grade-item">
      <div class="grade-label">{{'SCOUTING.POSITION' | translate}}</div>
      <div class="grade-box grayshading">{{ positionText() }}</div>
    </div>
  }
  <br/>
  
  @if(shouldShowCapacity()) {
    <div class="grade-item">
      <div class="grade-label">{{'SCOUTING.CAPACITY' | translate}}</div>
      <div [class]="'grade-box ' + getCapacityClass()">{{ capacityText() }}</div>
    </div>
  }

  @if(shouldShowPlayerType()) {
    <div class="grade-item">
      <div class="grade-label">{{'SCOUTING.PLAYER_TYPE' | translate}}</div>
      <div class="grade-box grayshading">{{ playerTypeText() }}</div>
    </div>
  }

</div>
<div  class="grades-container">
  @if(shouldShowCurrentLevel()) {
    <div class="grade-item">
      <div class="grade-label">{{'SCOUTING.CURRENT_LEVEL' | translate}}</div>
      <div [class]="'grade-box ' + getProjectionClass()">{{ currentLevelRankingText() }}</div>
    </div>
  }

  <div class="grade-item">
    <div class="grade-label">{{'SCOUTING.PROJECTION' | translate}}</div>
    <div [class]="'grade-box ' + getProjectionClass()">{{ totalQualityText() }}</div>
  </div>
</div>
